.root {
  align-items: stretch;
  background: var(--color-secondary);
  border-bottom: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
}

.title {
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.steps {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.step {
  align-items: center;
  display: inline-flex;
  font-size: 13px;
  gap: 8px;
  opacity: 0.5;
}

.step-is-active {
  opacity: 1;
}

.step-is-done {
  opacity: 0.85;
}

.step-is-skipped {
  opacity: 0.4;
}

.indicator {
  align-items: center;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 999px;
  color: var(--color-muted);
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 11px;
  font-weight: 600;
  height: 20px;
  justify-content: center;
  line-height: 1;
  width: 20px;
}

.indicator-is-active {
  background: var(--color-primary);
  border-color: var(--color-primary);
  color: var(--color-primary-foreground, white);
}

.indicator-is-done {
  background: var(--color-success, #2e7d32);
  border-color: var(--color-success, #2e7d32);
  color: white;
}

.indicator-is-skipped {
  background: var(--color-secondary);
  border-color: var(--color-border);
  color: var(--color-muted);
}

.label {
  white-space: nowrap;
}

.skip-button {
  background: none;
  border: none;
  color: var(--color-primary);
  cursor: pointer;
  font-size: 12px;
  margin-left: 4px;
  padding: 0;
  text-decoration: underline;
}

.skip-button:disabled {
  color: var(--color-muted);
  cursor: not-allowed;
}
